import fromEntries from 'object.fromentries'
import 'url-search-params-polyfill'

if (!Object.fromEntries) {
  fromEntries.shim()
}
